import axios from 'axios';
import moment from 'moment';
import React,{useEffect,useState,useRef} from 'react'
import { Crousal } from './Crousal';
import { Loader } from './Loader';

export const Weather=React.memo(() =>{
  const [state,setState]=useState({
    loading:true,
    data:{},
    errorMessage:""
  });
  const ref=useRef(moment().format("LTS"))
 useEffect(()=>{
  axios.get("https://api.openweathermap.org/data/3.0/onecall?lat=24.8607&lon=67.0011&exclude=minutely,hourly&appid=cdefd555ce980dcf18b16194dfc84fb1&units=metric").then((data)=>{
  setState((pre)=>{
    return {...pre,loading:false,data:data.data}
   })
  }).catch((e)=>{
    console.log(e)
  }) 
 },[])
   useEffect(()=>{
   let time=setInterval(()=>{
    ref.current.innerText=moment().format("LTS");
   },1000)
   return (()=>{
    clearInterval(time);
   })
   },[])
 if(!state.loading){
  let current="night";
  if(new Date().valueOf() / 1000 < state.data.current.sunset){
    current="day";
  }

  return (
    <>
    <div className="col-xl-12">
    <div className="row">
     <div className="col-xl-12">
       <div className="card mb-3">
         <div className="card-body" style={{padding:"10px"}}>
           {/* BEGIN title */}
           <div className="fw-bold small mb-3">
             <div className="col-12">
               <h6 className="">Karachi Pakistan</h6>
             </div>
             
           </div>
           <hr style={{margin:"1rem -12px",marginTop: "-10px"}}/>
            <div className="col-12">
              <div className="row">
                <div className="col-8">
                <div className="fw-bold small mb-3">
                <div className="col-12">
               <h7>{moment().format("dddd MMM DD,YYYY")}</h7> <br/>
               <h4 ref={ref}>{moment().format("LTS")}</h4> 
                <div style={{display:"flex",justifyContent:"space-between",width:"80%"}}>
                  <div >
                    <h7 className="small">SunRise:<br/> <span>{moment.unix(state.data.current.sunrise).format("h:mm a")}</span></h7>
                  </div>
                  <div >
                  <h7 className="small">SunSet:<br/> <span>{moment.unix(state.data.current.sunset).format("h:mm a")}</span></h7>
                  </div>
                </div>
             </div>
             
           </div>
                </div>
                <div className="col-4">
                <img src={`assets/img/weather/${current}${state.data.current.weather[0].main}.svg`} style={{width:"80px"}}/>
                
                <h5> {state.data.current.temp}<span style={{fontSize:"14px"}}>&#8451;</span></h5>
                
                <p className='fw-bold' style={{fontSize:"12px"}}>Feel like: {state.data.current.feels_like}<span>&#8451;</span></p>
                </div>
              </div>
            </div>
            <hr style={{margin:"1rem -12px",marginTop: "-10px"}}/>
            <div className="col-12">
            <Crousal data={state.data.daily}/>
            </div>
           {/* END title */}
           {/* BEGIN chart */}
         </div>
         <div className="card-arrow">
           <div className="card-arrow-top-left" />
           <div className="card-arrow-top-right" />
           <div className="card-arrow-bottom-left" />
           <div className="card-arrow-bottom-right" />
         </div>
         {/* END card-arrow */}
       </div>
       {/* END card */}
     </div>
   </div>
    </div>
  

    </>
   );
 }
 else{
  <Loader/>
 }
      
}
)